import React from 'react';
import useAuth from '../../../hooks/useAuth';
import welcome from '../../../../src/images/welcome.gif'

const DashBoardHome = () => {
    const { user } = useAuth();
    return (
        <div>
            <h1>Welcome To the Dashboard, {user.displayName}</h1>
            <img src={welcome} alt="" />
        </div>
    );
};

export default DashBoardHome;